import { DataGridSelection } from '@rematter/ui-web';
import { atom } from 'jotai';

import { itemAliasDeleteAtom } from '../_graphql/mutationItemAliasDelete';
import { itemAliasesListQueryAtom } from '../_graphql/queryItemAliasesList';
import {
  enumItemAliasSortOption,
  ItemAliasRecord,
  ItemAliasSortOption,
  ItemAliasType,
} from '../types/inventoryItem';

import { atomFromQueryString } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $searchTerm = atomFromQueryString.string('q');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);
export const $selectedItemIds = atomFromQueryString.stringSet('itemIds');
export const $selectedAccountIds = atomFromQueryString.stringSet('accountIds');
export const $selectedAliasTypes =
  atomFromQueryString.stringSet<ItemAliasType>('aliasTypes');

// 🔘🔘🔘 PLAIN ATOMS
export const $selectedKeys = atom<DataGridSelection>(new Set<React.Key>());
export const $isCreateDialogOpen = atom<boolean>(false);
export const $selectedItemAlias = atom<ItemAliasRecord | null>(null);
export const $currentSorting = atom<ItemAliasSortOption[]>([
  enumItemAliasSortOption.AliasNameAsc,
]);

// 🟢🟢🟢 REMOTE DATA
export const $remoteItemAliases = itemAliasesListQueryAtom((get) => {
  const searchTerm = get($searchTerm);
  const limit = get($limit);
  const offset = get($offset);
  const itemIds = Array.from(get($selectedItemIds));
  const accountIds = Array.from(get($selectedAccountIds));
  const aliasTypes = Array.from(get($selectedAliasTypes));
  const sorting = get($currentSorting);

  return {
    variables: {
      searchTerm: searchTerm || undefined,
      itemIds: itemIds.length > 0 ? itemIds : undefined,
      accountIds: accountIds.length > 0 ? accountIds : undefined,
      aliasTypes: aliasTypes.length > 0 ? aliasTypes : undefined,
      limit,
      offset,
      sorting,
    },
  };
});

// 🟠🟠🟠 ACTION -> DELETE item alias
export const $deleteItemAlias = itemAliasDeleteAtom({
  onSuccess: (get) => {
    get($remoteItemAliases).refetch?.();
  },
});
